import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/pagina-nao-encontrada.svg'


const _hoisted_1 = { class: "error-404-view w-100 h-100 d-flex justify-content-center align-items-center flex-column" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "title-error-view col-12" }
const _hoisted_4 = { class: "col-12 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "col-12" }, "Ops! Página não encontrada.", -1)),
        _createElementVNode("p", _hoisted_4, [
          _createTextVNode(" O endereço www." + _toDisplayString(_ctx.baseUrl) + "/", 1),
          _createElementVNode("b", null, _toDisplayString(_ctx.subdomain), 1)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("p", { class: "col-12" }, "não foi encontrada ou não existe.", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "col-12" }, " Verifique se você digitou corretamente e tente novamente. ", -1))
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "imagem-error-view col-12 mt-4" }, [
        _createElementVNode("img", {
          alt: "Página não encontrada",
          src: _imports_0
        })
      ], -1))
    ])
  ]))
}